// import '@fontsource/roboto/300.css';
// import '@fontsource/roboto/400.css';
// import '@fontsource/roboto/500.css';
// import '@fontsource/roboto/700.css';
import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3';
import merge from 'lodash/merge';
import React from 'react';
import palette from 'src/customizations/themes/10-parts/color-schemes/palette';
import useTheme from 'src/customizations/themes/hooks/useTheme';
import createThemedStyle from 'src/customizations/themes/utils/createThemedStyles';
const commonThemeSettings = {
    typography: {
        fontFamily: "'Montserrat', sans-serif",
    },
    palette: {
        primary: {
            main: palette.brand['500'],
        },
    },
};
const MUISetup = ({ children }) => {
    const [{ theme }] = useTheme(stylesGenerator);
    const isLight = theme.themeID === 'light';
    const background = theme.palette.background.main;
    const muiTheme = createTheme(merge(commonThemeSettings, {
        palette: {
            mode: isLight ? 'light' : 'dark',
            background: {
                default: background,
                paper: theme.palette.background.subtle,
            },
        },
    }));
    return (React.createElement(ThemeProvider, { theme: muiTheme },
        React.createElement(CssBaseline, null),
        React.createElement(LocalizationProvider, { dateAdapter: AdapterDateFns }, children)));
};
const stylesGenerator = createThemedStyle(({}) => ({}));
export default MUISetup;
